import { iParams } from '../shared/UITypes/types';
import AppService from './AppService';

const getJobAttributeValues = (config?: iParams) => {
  return AppService.get('/jobAttributeValue', config).then(({ data }) => data);
};
export default { getJobAttributeValues };
